export enum OnboardingDialogClose {
  SKIP = 'skip',
  END = 'end',
  NEXT = 'next',
  DISCOVER = 'discover',
  AGREED = 'agreed',
  DISAGREED = 'disagreed',
  CONTINUE = 'Continue',
}
